import HomeController from './Home';
import CompsController from './Comps';
import AccountController from './Account';
import TippingController from "./Tipping";
import OnboardingController from "./Onboarding";
import ActivateGameController from "./ActivateGame";
import HelpController from './Help';
import StreakController from './Streak';
import PreseasonController from './Preseason';
import PasswordController from './Password';

export * from './Rankings';

export {
	HomeController,
	CompsController,
	AccountController,
	TippingController,
	OnboardingController,
	ActivateGameController,
	HelpController,
	StreakController,
	PreseasonController,
	PasswordController,
};

export default {
	HomeController,
	CompsController,
	AccountController,
	TippingController,
	OnboardingController,
	ActivateGameController,
	HelpController,
	StreakController,
	PreseasonController,
	PasswordController,
}